module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('label', [_vm._v(_vm._s(_vm.t('Name')))]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "name"
    },
    domProps: {
      "value": _vm.name
    },
    on: {
      "keyup": function($event) {
        return _vm.getName($event)
      }
    }
  }), _vm._v(" "), (_vm.errors && _vm.errors.name) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.t(_vm.errors.name)))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('h4', [_vm._v(_vm._s(_vm.t('Formulas')))]), _vm._v(" "), _vm._l((_vm.formulaService.getAll()), function(item) {
    return _c('drag', {
      staticClass: "drag btn btn-info",
      attrs: {
        "data": item
      }
    }, [_vm._v("\n                    " + _vm._s(item.getName()) + "\n                ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('h4', [_vm._v(_vm._s(_vm.t('Arguments')))]), _vm._v(" "), _vm._l((_vm.formulaAttributesService.getAll()), function(item) {
    return _c('drag', {
      staticClass: "drag btn btn-info",
      attrs: {
        "data": item
      }
    }, [_vm._v("\n                    " + _vm._s(item.getName()) + "\n                ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('h4', [_vm._v(_vm._s(_vm.t('Value')))]), _vm._v(" "), _vm._l((_vm.formulaValueService.getAll()), function(item) {
    return _c('drag', {
      staticClass: "drag btn btn-info",
      attrs: {
        "data": item
      }
    }, [_vm._v("\n                    " + _vm._s(item.getName()) + "\n                ")])
  })], 2)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-00489242!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DynamicPricingRule/DragComponent.vue
// module id = 1221
// module chunks = 2